import styled from 'styled-components';

interface IBankAccountRow {
  $isNew: boolean;
}

export const BankAccountRow = styled.div<IBankAccountRow>`
  display: grid;
  grid-template-columns: ${({ $isNew }) => ($isNew ? '1fr' : 'repeat(2, minmax(0, 1fr))')};
  column-gap: 16px;
  row-gap: ${({ $isNew }) => ($isNew ? '16px' : '0')};
  width: 100%;

  & > * {
    min-width: 0;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    row-gap: 16px;
  }
`;
